import React, { useEffect, useState } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './PageAbout.scss';
import './PageAbout-media.scss';
import Content from '../../components/Content/Content';
import Title from '../../components/Title/Title';
import {ListMedia, ListPrinciples, pageContent, SliderGalleryList} from './content';
import Counter from '../../components/Counter/Counter';
import CardPhoto from '../../components/CardPhoto/CardPhoto';
import CardMedia from '../../components/CardMedia/CardMedia';
import { MediaContent, ValidationFormItems, bodyAuto } from '../../services/GlobalFunctions';
import { ServiceData } from '../../redux/services/ServiceRedux';
import YoutubeBlock from '../../components/YoutubeBlock/YoutubeBlock';
import ModalForm from '../../components/ModalForm/ModalForm';
import Button from '../../components/Button/Button';
import { Props } from './interfaces';
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

const PageAbout = ({
  about,
  aboutLoaded,
  alertLoaded,
  widthWindow,
  blockedSend,
  blockedSendLoaded,
  recaptchaV2ref,
  contactForms
}: Props) => {
  useEffect(() => {
    ServiceData.getAll({aboutLoaded, alertLoaded});
  }, [])

  const [phoneForm, setPhoneForm] = useState('+7');
  const [errorPhoneForm, setErrorPhoneForm] = useState<string | null>(null);

  const [serverText, setServerText] = useState('');
  const [successShow, setSuccessShow] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const closedModal = () => {
    bodyAuto();
    setShowPopup(false);
  };
  const OnClickDirector = (e: any) => {
    e.preventDefault();
    setShowPopup(true);
  };

  const { executeRecaptcha } = useGoogleReCaptcha(); // v3

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();
    setDisableBtn(true);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    // v3
    if (!executeRecaptcha) {
      setDisableBtn(false);
      return;
    }

    const token = await executeRecaptcha(); // v3
    // const token = await recaptchaV2ref.current.executeAsync();

    if (!ValidationFormItems({phone: phoneForm, setErrorPhone: setErrorPhoneForm})) {
      setDisableBtn(false);
      return;
    }
    ServiceData.sendEmailContacts({
      data: {name: '', phone: phoneForm, page: 'Стать частью команды', department: 2, msg: '-'},
      setServerText,
      success,
      token,
      blockedSendLoaded,
      eventMetrika: 'form_team',
      contactFormId: contactForms.main_contact_form_id
    });
  };

  const success = () => {
    setPhoneForm('+7');

    setSuccessShow(true);
    setTimeout(() => setSuccessShow(false), 3000);
    setDisableBtn(false);
  };

  return (
    <div className="page-about">

      <YoutubeBlock
        video={'gh6K1j2gGEg'}
        poster={require('./img/poster.png')}
        height="56.3vw"
        heightMob="56.3vw"
        fullWidth
        fullText="История<br/> длиною в 10 лет"
      />

      <Content
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        bgInto={<div className="page-about__bg-2"></div>}
        block={
          <>
            <Title title="Наши принципы" center/>

            <div className="page-about__grid-2">
              {ListPrinciples.map((item, i) => (
                <div className="page-about__card" key={i}>
                  <h3 dangerouslySetInnerHTML={{__html: item}}></h3>
                </div>
              ))}
            </div>
          </>
        }
      />

      {pageContent.counters && <Content
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          block={
            <>
              <Title title={pageContent.counters.title} text={pageContent.counters.subtitle} center/>
              <div className="page-about__bg-7"></div>
              <div className="page-about__grid-counts">
                {pageContent.counters.items.map((item, i) => (
                  <Counter {...item} key={i}/>
                ))}
              </div>
            </>
          }
      />}

      <Content
        padding={{paddingMain: {top: 80, bottom: 0}, paddingMob: {top: 40, bottom: 40}}}
        block={
          <>
            <Title title={about.titleFaces} center/>
            <div className="page-about__form-director">
              {MediaContent(<span></span>, null)}
              {MediaContent(<span className="page-about__bg-director"></span>, null)}
              {MediaContent(
                <img
                  src={require('./img/ekaterina-anciferova.webp')}
                  className="page-about__form-director-photo"
                  alt=""
                />,
                null
              )}
              <div className="page-about__form-director-content">
                <h3>Мы дорожим репутацией, бережно относимся к каждому клиенту</h3>
                <p className="body1 page-about__form-text">
                  Напишите лично мне, если: у вас возник вопрос, на который никто не смог дать ответ; вам
                  потребовалась помощь, которую не смогли оказать; появилось предложение, связанное с
                  доставкой, работой курьеров и др.
                </p>
                <p className="body1 page-about__name">Екатерина Анциферова</p>
                <p className="body2 page-about__form-director-position">
                  Заместитель генерального директора по коммерции
                </p>
                <Button
                  text="Написать"
                  type="border"
                  size={widthWindow > 720 ? 'L' : 'M'}
                  onClick={OnClickDirector}
                />
                {MediaContent(
                  null,
                  <span className="page-about__form-director-span-height">
                    <img
                      src={require('./img/ekaterina-anciferova.webp')}
                      className="page-about__form-director-photo"
                      alt=""
                    />
                    <span className="page-about__bg-director"></span>
                  </span>
                )}
              </div>

              <ModalForm
                hasCssTransition
                showForm={showPopup}
                id="director"
                title="Написать сообщение"
                buttonText="Написать"
                image={require('./img/ekaterina-anciferova.webp')}
                closedModal={closedModal}
                textarea
                eventMetrika="form_director"
                sendAmoCRM
              />
            </div>
          </>
        }
      />

      {about.employees.length ? (
        <Content
          padding={{paddingMain: {top: 0, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          block={
            <div className="page-about__grid-3">
              <div className="page-about__bg-2-photos"></div>
              {about.employees.map((item, i) => (
                <CardPhoto {...item} key={i}/>
              ))}
            </div>
          }
        />
      ) : null}

      <Content
        padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
        block={
          <>
            <Title title="Медиа о нас" center/>
            <div className="page-about__grid-3 page-about__media">
              {ListMedia.map((item, i) => (
                <CardMedia {...item} key={i}/>
              ))}
            </div>
          </>
        }
      />

      {/* <Content
        padding={{ paddingMain: { top: 80, bottom: 0 }, paddingMob: { top: 40, bottom: 0 } }}
        block={
          <FormContainer
            title="Не сидите на скамье запасных, выходите на поле"
            subTitle=""
            image={widthWindow > 720 ? require('./img/uliya.png') : null}
            imageText={`<p class="body1">Рожкова Юлия</p>
            <p class="body2">Менеджер по развитию клиентов</p>`}
            widthRight={widthWindow > 720 ? '698px' : ''}
            buttonText="Стать частью команды"
            buttonWidthAll
            disableBtn={disableBtn}
            showBlockedError={showBlockedError}
            form={
              <>
                <div className="page-about__form-content">
                  <Tel phone="+7 (495) 181-08-31" tag="h4" />
                  <MailTo mail="hr@dalli-service.com" tag="h4" />
                </div>
                <InputPhone
                  label="Телефон*"
                  name="phone"
                  value={phoneForm}
                  onChange={(e: any) => setPhoneForm(e.target.value)}
                  error={errorPhoneForm}
                  marginTop={0}
                />
              </>
            }
            onSubmit={handleReCaptchaVerify}
            serverText={serverText}
            successShow={successShow}
            heightSuccessForm="608px"
          />
        }
      /> */}
    </div>
  );
}

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageAbout));
